import { LF } from 'containers/LineasFinancieras/Constantes/general';
export const Productos_Bloqueados_Opcion_Manual = [
    LF.prodCodigoCore    
];
